import React from "react";
import "./index.css";

export function PageFooter({ className = "" }) {
  return (
    <div className={`page-footer ${className}`}>
      <div className="page-footer-links">
        <a
          href="https://thirdverse.io/en/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>
        <a
          href="https://docs.google.com/document/d/1SjgzotlZzYFzOkQuQcwbHyhK4kcDKDsnv_lu5P3RIBA/edit?tab=t.0"
          target="_blank"
          rel="noopener noreferrer"
        >
          Guidelines
        </a>
        <a
          href="https://thirdverse.io/en/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>
      <div className="page-footer-copyright">
        &copy; ’25 SANRIO CO., LTD. APPR. NO. N660002
      </div>
    </div>
  );
}

